import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Offerings from './components/Offerings';
import Values from './components/Values';
import StayInTouch from './components/StayInTouch';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="w-full overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <Offerings />
      <Values />
      <StayInTouch />
      <Footer />
    </main>
  );
}
